// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__14HId","author":"Table_author__ptDYz","authorImage":"Table_authorImage__1kzzB","unreadRow":"Table_unreadRow__1qpNH"};